import { render, staticRenderFns } from "./ChartPanel.vue?vue&type=template&id=5631a8b6&scoped=true"
import script from "./ChartPanel.vue?vue&type=script&lang=js"
export * from "./ChartPanel.vue?vue&type=script&lang=js"
import style0 from "./ChartPanel.vue?vue&type=style&index=0&id=5631a8b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5631a8b6",
  null
  
)

export default component.exports